export function setBrandTheme(brand) {
  const root = document.documentElement;

  Object.entries(brand).forEach(([key, value]) => {
    root.style.setProperty(`--${key}`, value);
  });
}

export function resetBrandTheme() {
  const root = document.documentElement;

  const styles = {
    dark: "#49677D",
    "dark-active": "#587A93",
    light: "#E8F0F6",
    "light-active": "#D9ECFA",
    highlight: "#0094FF",
    accent: "#F4F3EC",
    "button-primary": "#49677D",
    "button-primary-text": "#FFFFFF",
    "button-secondary": "#E8F0F6",
    "button-secondary-text": "#49677D",
  };

  Object.entries(styles).forEach(([key, value]) => {
    root.style.setProperty(`--${key}`, value);
  });
}
